<app-base-modal
  [title]="documentResourceType.name"
  size="large"
  [showStateToggle]="hasEditPermission"
>
  <div class="modal-header">
    <a
      mat-button
      class="document-disk-link"
      color="primary"
      target="_blank"
      [disabled]="!documentsData?.documentDiskLink"
      [href]="documentsData?.documentDiskLink"
    >
      Диск документов
    </a>
  </div>
  @if (documentForm) {
    <form [formGroup]="documentForm">
      <div class="rows">
        @for (row of documentRows; track $index) {
          <div
            [formGroupName]="row.key"
            class="row"
          >
            <button
              [appIconStatus]="getBtnIconStatus(row.documentRow.key)"
              [autofocus]="false"
              mat-stroked-button
              color="primary"
              type="button"
              class="row-btn"
              (click)="handleBtnClick(row.key)"
            >
              {{ row.title }}
            </button>
            <div class="row-fields">
              @for (field of row.documentRow.rowFields; track $index) {
                @switch (field.type) {
                  @case ('select') {
                    <mat-form-field
                      [class]="setFieldClasses()"
                      appearance="outline"
                    >
                      <mat-label>{{ field.label }}</mat-label>
                      <mat-select
                        [formControlName]="field.fieldName"
                        [value]="getCurrentStatusValue(row.documentRow.key)"
                        (selectionChange)="handleSelectChange($event.value, row.key)"
                      >
                        <mat-option></mat-option>
                        @for (option of getStatusOptions(row.documentRow.key); track $index) {
                          <mat-option [value]="option.value">
                            {{option.title}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @case ('text') {
                    @if (field.isLink) {
                      <mat-form-field
                        appearance="outline"
                        [class]="setFieldClasses()"
                        [style]="getFieldStyles({ formControlName: field.fieldLinkName, formGroup: documentForm })"
                        (click)="handleValueClick({ formControlName: field.fieldLinkName, formGroup: documentForm })"
                      >
                        <mat-label>{{ field.label }}</mat-label>
                        <input
                          [formControlName]="field.fieldName"
                          matInput
                          type="text"
                          (blur)="handleInputChange(row.key, field.fieldName)"
                          (change)="handleInputChange(row.key, field.fieldName)"
                        >
                      </mat-form-field>
                    } @else {
                      <mat-form-field
                        appearance="outline"
                        [class]="getTextClasses(row.key)"
                      >
                        <mat-label>{{ field.label }}</mat-label>
                        <input
                          [formControlName]="field.fieldName"
                          matInput
                          type="text"
                        >
                      </mat-form-field>
                    }
                  }
                  @case ('date') {
                    <mat-form-field
                      appearance="outline"
                      class="date"
                      [class]="setFieldClasses()"
                    >
                      <mat-label>{{ field.label }}</mat-label>
                      <input
                        matInput
                        appDateInput
                        [matDatepicker]="datePicker"
                        [formControlName]="field.fieldName"
                        (dateChange)="handleDateChange($event, row.key)"
                        placeholder="ДД.ММ.ГГГГ"
                      >
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="datePicker"
                      >
                      </mat-datepicker-toggle>
                      <mat-datepicker #datePicker></mat-datepicker>
                    </mat-form-field>
                  }
                  @case ('button') {
                    @if (field.isIconStatus) {
                      <button
                        [appIconStatus]="fetchIconStatus(field.statusBtnName)"
                        mat-stroked-button
                        color="primary"
                        type="button"
                        class="contract-btn"
                        [class]="setFieldClasses()"
                        [disabled]="isDisabledButton()"
                        (click)="handleBtnClick(field.fieldName)"
                      >
                        {{ field.label }}
                      </button>
                    } @else {
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        class="contract-btn"
                        [class]="setFieldClasses()"
                        [disabled]="isDisabledButton()"
                        (click)="handleBtnClick(field.fieldName)"
                      >
                        {{ field.label }}
                      </button>
                    }
                  }
                }
              }
            </div>
          </div>
          @if (row.isSeparator) {
            <div class="separator"></div>
          }
        }
      </div>
    </form>
  }

  <div class="buttons-container">
    @if (!isEditModeActive) {
      <button
        mat-button
        color="primary"
        (click)="closeDialog('cancel')"
      >
        Закрыть
      </button>
    } @else {
      <button
        mat-button
        class="save-button"
        (click)="handleUpdateDocument()"
      >
        Сохранить
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('cancel')"
      >
        Отменить
      </button>
    }
  </div>
</app-base-modal>
